export enum Paths {
  Info = '/info',
  Test = '/test/:id',
}
